var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Layout } from "@consta/uikit/Layout";
import { Modal } from "@consta/uikit/Modal";
import cn from "classnames";
import styles from "./CustomModal.module.scss";
var CustomModal = function (_a) {
    var onClose = _a.onClose, openBtn = _a.openBtn, closeBtn = _a.closeBtn, children = _a.children, className = _a.className, _b = _a.isOpened, isOpened = _b === void 0 ? false : _b, _c = _a.hasOverlay, hasOverlay = _c === void 0 ? false : _c;
    var _d = useState(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var openModal = useCallback(function () {
        setIsModalOpen(function (isOpen) { return !isOpen; });
    }, []);
    var closeModal = useCallback(function () {
        setIsModalOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, []);
    useEffect(function () {
        setIsModalOpen(isOpened);
    }, [isOpened]);
    return (_jsxs(Layout, __assign({ className: styles.modalWrapper }, { children: [openBtn && (_jsx("div", __assign({ className: styles.btnWrapper, role: "button", onClick: openModal }, { children: openBtn }))), _jsx(Modal, __assign({ className: cn(styles.modal, className), hasOverlay: hasOverlay, isOpen: isModalOpen, onClickOutside: closeModal, onEsc: closeModal }, { children: _jsxs(Layout, __assign({ className: styles.modalContent }, { children: [children, _jsx("div", __assign({ className: styles.btnWrapper, role: "button", onClick: closeModal }, { children: closeBtn }))] })) }))] })));
};
export default CustomModal;
